// Size processor module
// Converts {{size: 2rem}}text{{/size}} notation to styled spans
// Supports CSS font-size values: 2rem, 1.5em, 24px, 120%, small, etc.

export function initSizeProcessor() {
  const isPostPage = document.body.classList.contains('post-template') ||
                    document.body.classList.contains('page-template') ||
                    document.querySelector('.gh-content');

  if (!isPostPage) return;

  const contentElement = document.querySelector('.gh-content');
  if (!contentElement) return;

  const sizeRegex = /\{\{size:\s*([^}]+)\}\}([\s\S]*?)\{\{\/?size\}\}/g;

  const selectors = 'p, li, figcaption, .kg-callout-text, h1, h2, h3, h4, h5, h6, blockquote, td, th';
  const elements = contentElement.querySelectorAll(selectors);

  elements.forEach(element => {
    if (element.closest('.announcement-bar, [class*="announcement"]')) {
      return;
    }

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      const parent = node.parentNode;
      if (parent && parent.tagName === 'SPAN' && parent.style.fontSize) {
        continue;
      }
      textNodes.push(node);
    }

    textNodes.forEach(textNode => {
      const text = textNode.textContent;
      const matches = [...text.matchAll(sizeRegex)];

      if (matches.length === 0) return;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;

      matches.forEach(match => {
        if (match.index > lastIndex) {
          fragment.appendChild(
            document.createTextNode(text.slice(lastIndex, match.index))
          );
        }

        const sizeValue = match[1].trim();
        const sizedText = match[2];

        const span = document.createElement('span');
        span.style.fontSize = sizeValue;
        span.style.color = 'inherit';
        span.style.fontStyle = 'inherit';
        span.style.fontWeight = 'inherit';
        span.style.lineHeight = 'inherit';
        span.style.letterSpacing = 'inherit';
        span.textContent = sizedText;

        fragment.appendChild(span);

        lastIndex = match.index + match[0].length;
      });

      if (lastIndex < text.length) {
        fragment.appendChild(
          document.createTextNode(text.slice(lastIndex))
        );
      }

      if (textNode.parentNode && textNode.parentNode !== contentElement) {
        textNode.parentNode.replaceChild(fragment, textNode);
      }
    });
  });
}
